import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjSeismdataVertS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.5 2C3.22386 2 3 2.22386 3 2.5L3 12.2929L1.85355 11.1464C1.65829 10.9512 1.34171 10.9512 1.14645 11.1464C0.951184 11.3417 0.951184 11.6583 1.14645 11.8536L3.14645 13.8536C3.34171 14.0488 3.65829 14.0488 3.85355 13.8536L5.85355 11.8536C6.04882 11.6583 6.04882 11.3417 5.85355 11.1464C5.65829 10.9512 5.34171 10.9512 5.14645 11.1464L4 12.2929L4 2.5C4 2.22386 3.77614 2 3.5 2Z"
        fill="#32B4FF"
      />
      <path
        d="M12.2124 12.3176C11.7654 12.7648 11.2226 13.1525 10.6453 13.448C10.4127 13.567 10.1277 13.4748 10.0087 13.2421C9.88969 13.0093 9.98182 12.724 10.2145 12.605C10.7062 12.3533 11.1684 12.0232 11.5433 11.6481C13.5572 9.63288 13.5572 6.36557 11.5433 4.35035C11.1521 3.95895 10.7121 3.64085 10.2283 3.39598C9.99516 3.27797 9.90175 2.99316 10.0197 2.75984C10.1376 2.52653 10.4223 2.43305 10.6554 2.55107C11.2283 2.84103 11.7501 3.21824 12.2124 3.68083C14.5959 6.06581 14.5959 9.93263 12.2124 12.3176ZM9.84946 10.6995C9.51423 11.0349 9.10184 11.3113 8.66314 11.5037C8.42381 11.6086 8.14477 11.4996 8.0399 11.2601C7.93502 11.0206 8.04402 10.7414 8.28335 10.6364C8.61667 10.4903 8.93056 10.2799 9.18035 10.03C10.3012 8.90841 10.3012 7.09003 9.18035 5.96849C8.93177 5.71976 8.6297 5.51826 8.29331 5.37097C8.05392 5.26616 7.94477 4.98701 8.04952 4.74747C8.15426 4.50793 8.43324 4.39872 8.67262 4.50353C9.11408 4.69681 9.51483 4.96413 9.84946 5.29897C11.3398 6.79028 11.3398 9.20817 9.84946 10.6995Z"
        fill="#97B2C4"
      />
    </svg>
  )
}
export const IconGeoObjSeismdataVert = createIcon({
  l: IconGeoObjSeismdataVertS,
  m: IconGeoObjSeismdataVertS,
  s: IconGeoObjSeismdataVertS,
  xs: IconGeoObjSeismdataVertS,
  name: 'IconGeoObjSeismdataVert',
})
